import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { BasicInfoComponent } from './BasicInfo/BasicInfo.component';
import { ConnectedUsersFloatingPanelComponent } from './ConnectedUsersFloatingPanel/ConnectedUsersFloatingPanel.component';
import { ContactAttemptsComponent } from './ContactAttempts/ContactAttempts.component';
import { CustomActionsReportComponent } from './CustomActionsReport/CustomActionsReport.component';
import { CustomerNotesComponent } from './customer-notes/customer-notes.component';
import { CustomerSynopsisComponent } from './CustomerSynopsis/CustomerSynopsis.component';
import { CustomerTodoListFloatingPanelComponent } from './CustomerTodoListFloatingPanel/CustomerTodoListFloatingPanel.component';
import { CustomerTodoListTicketComponent } from './CustomerTodoListTicket/CustomerTodoListTicket.component';
import { CustomReportsComponent } from './CustomReports/CustomReports.component';
import { DescendantsComponent } from './Descendants/Descendants.component';
import { FeaturesComponent } from './Features/Features.component';
import { FilesComponent} from './files/files.component';
import { ForceCustomerRefreshComponent } from './ForceCustomerRefresh/ForceCustomerRefresh.component';
import { KeywordResearchComponent } from './KeywordResearch/KeywordResearch.component';
import { StrategyUpdateComponent } from './StrategyUpdate/StrategyUpdate.component';
import { CustomerCampaignComponent } from './customer-campaign/customer-campaign.component';
import { LinkBuildingComponent } from './LinkBuilding/LinkBuilding.component';
import { LocalProfilesComponent } from './local-profiles/LocalProfiles.component';
import { LockConfirmationComponent } from './LockConfirmation/LockConfirmation.component';
import { SeoContentSurveyComponent } from './SeoContentSurvey/SeoContentSurvey.component';
import { NoteComponent } from './Note/Note.component';
import { NoteFloatingPanelComponent } from './NoteFloatingPanel/NoteFloatingPanel.component';
import { OnsiteCopyImplementationNotesComponent } from './OnsiteCopyImplementationNotes/OnsiteCopyImplementationNotes.component';
import { OnsiteCopyRequestComponent } from './OnsiteCopyRequest/OnsiteCopyRequest.component';
import { LoginsAndPublishOptionsComponent } from './logins-and-publish-options/logins-and-publish-options.component';
import { OnsiteRecommendationsCompleteComponent } from './OnsiteRecommendationsComplete/OnsiteRecommendationsComplete.component';
import { WebsiteAuditComponent } from './website-audit/website-audit.component';
import { LocalProfileInitializationComponent } from './local-profile-initialization/local-profile-initialization.component';
import { EmailSettingsComponent } from './email-settings/email-settings.component';
import { ReportingAccessComponent } from './ReportingAccess/ReportingAccess.component';
import { RetentionComponent } from './Retention/Retention.component';
import { ReviewComponent } from './Review/Review.component';
import { TicketComponent } from './Ticket.component';
import { TicketCompleteConfirmationComponent } from './TicketCompleteConfirmation/TicketCompleteConfirmation.component';
import { TicketNavigationComponent } from './TicketNavigation/TicketNavigation.component';
import { TicketNavigationFloatingPanelComponent } from './TicketNavigationFloatingPanel/TicketNavigationFloatingPanel.component';
import { TicketTimerComponent } from './TicketTimer/TicketTimer.component';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { BlogAndCopyContentReviewComponent } from './blog-and-copy-content-review/blog-and-copy-content-review.component';
import { UpaChecklistComponent } from './upa-checklist/upa-checklist.component';
import { ManageCustomerModule } from '../managecustomer/manage-customer.module';
import { InvalidUrlComponent } from './invalid-url/invalid-url.component';
import { SeoStarterOnboardingLinkComponent } from './seo-starter-onboarding-link/seo-starter-onboarding-link.component';


@NgModule({
  declarations: [
    BasicInfoComponent,
    ConnectedUsersFloatingPanelComponent,
    ContactAttemptsComponent,
    CustomActionsReportComponent,
    CustomerNotesComponent,
    CustomerSynopsisComponent,
    CustomerTodoListFloatingPanelComponent,
    CustomerTodoListTicketComponent,
    CustomReportsComponent,
    DescendantsComponent,
    FeaturesComponent,
    FilesComponent,
    ForceCustomerRefreshComponent,
    KeywordResearchComponent,
    StrategyUpdateComponent,
    CustomerCampaignComponent,
    LinkBuildingComponent,
    LocalProfilesComponent,
    LockConfirmationComponent,
    SeoContentSurveyComponent,
    NoteComponent,
    NoteFloatingPanelComponent,
    OnsiteCopyImplementationNotesComponent,
    OnsiteCopyRequestComponent,
    LoginsAndPublishOptionsComponent,
    OnsiteRecommendationsCompleteComponent,
    WebsiteAuditComponent,
    LocalProfileInitializationComponent,
    EmailSettingsComponent,
    ReportingAccessComponent,
    RetentionComponent,
    ReviewComponent,
    TicketComponent,
    TicketCompleteConfirmationComponent,
    TicketNavigationComponent,
    TicketNavigationFloatingPanelComponent,
    TicketTimerComponent,
    BlogAndCopyContentReviewComponent,
    UpaChecklistComponent,
    InvalidUrlComponent,
    SeoStarterOnboardingLinkComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedComponentsModule,
    ManageCustomerModule
  ]
})
export class TicketModule { }
